import React, { useState, useEffect } from "react";
import { X } from 'lucide-react';
import Chip from "./Chip";
import { User } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal, Pagination } from "antd";
import FlexBtn from "../Common/FlexBtn";
import { useTranslation } from "react-i18next";
import { getRequest, postRequest } from "../../services";
import { Spin } from 'antd';

const Course = (prop) => {
  const { count = 4, useToggle = true, homeRender, suggested, coursesPerPage } = prop;
  const toggleFilter = useSelector((state) => state.toggler.toggleFilter);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [myData, setMyData] = useState();
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [suggestedCourses, setSuggestedCourses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language;
  const navigate = useNavigate();
  const [chunkSize, setChunkSize] = useState(3);
  const auth = JSON.parse(localStorage.getItem("user"));

  // Determine chunk size based on screen width
  const updateChunkSize = () => {
    const width = window.innerWidth;
    if (width >= 992) {
      setChunkSize(3);
    } else if (width >= 768) {
      setChunkSize(2);
    } else {
      setChunkSize(1);
    }
  };

  useEffect(() => {
    updateChunkSize();
    window.addEventListener("resize", updateChunkSize);
    return () => window.removeEventListener("resize", updateChunkSize);
  }, []);

  function getInitials(name) {
    const parts = name.split(" ");
    let initials = "";
    for (let part of parts) {
      initials += part[0];
    }
    return initials;
  }

  const withToggleClassName = `${toggleFilter ? "col-md-6 col-xl-4" : "col-md-4 col-xl-3"} col-sm-6 cursor-pointer`;
  const withOutToggleClassName = `${homeRender ? "col-12 col-md-4" : "col-4"}  px-2 cursor-pointer`;

  const showModal = (course) => {
    setSelectedCourse(course);
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const response = await postRequest(`/api/Course/enroll?courseId=${selectedCourse.id}&studentId=${auth.userId}`);
      if (response.data.success) {
        setIsModalVisible(false);
        fetchEnrolledCourses();
        fetchDataCourses();
      }
    } catch (error) {
      console.error("Error enrolling in course:", error.message);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const fetchEnrolledCourses = async () => {
    setLoading(true);
    try {
      const response = await getRequest(`/api/Course/my-courses/${auth.userId}`);
      setEnrolledCourses(response.data.data);
    } catch (error) {
      console.error("Error fetching enrolled courses:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataCourses = async () => {
    setLoading(true);
    try {
      const response = await getRequest(`/api/Course`);
      const data = response.data.data;
      setMyData(data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataCourses();
    fetchEnrolledCourses();
  }, []);

  // Filter out enrolled courses from suggested courses
  useEffect(() => {
    if (myData?.items && enrolledCourses.length > 0) {
      const enrolledCourseIds = enrolledCourses.map(course => course.id);
      const filteredCourses = myData.items.filter(course => !enrolledCourseIds.includes(course.id));
      setSuggestedCourses(filteredCourses);
    } else if (myData?.items) {
      setSuggestedCourses(myData.items);
    }
  }, [myData, enrolledCourses]);

  // Pagination logic
  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = enrolledCourses.slice(indexOfFirstCourse, indexOfLastCourse);

  // Group courses into chunks for carousel
  const chunkArray = (arr, size) => {
    if (!arr) return [];
    const chunkedArr = [];
    for (let i = 0; i < arr.length; i += size) {
      chunkedArr.push(arr.slice(i, i + size));
    }
    return chunkedArr;
  };

  return (
    <Spin spinning={loading}>
      <div className="row pl-0">
        <h3 className={`myClassesHeading ${isArabic === "sa" ? "text-end" : ""}`}>{t('MyCourses')}</h3>
       
          {currentCourses.length > 0 ? (
            <>
              {currentCourses.map((course, index) => (
                <div
                  className={useToggle ? withToggleClassName : withOutToggleClassName}
                  onClick={() => navigate(`/course/${course.id}`, { state: { ...course } })}
                  key={index}
                >
                  <div className="col-12 col-md-12 customShadow  courseCard px-2 py-2 position-relative d-flex flex-column gap-2 my-2">
                    <div className="CourseThumbnail">
                      <img
                        src={course.coverImageUrl}
                        className="rounded h-100 w-100"
                        alt="course thumbnail"
                      />
                    </div>
                    <h6 className="mb-0 fw-bold">{course.name}</h6>
                    <div className="d-flex align-items-center courseInstructor d-md-flex flex-md-row flex-column">
                      <div className="d-flex">
                        <User className="userIcon" />
                        <h4 className="p-0 m-0 text-uppercase fg-main">
                          {getInitials("Muhammad Kashif")}
                        </h4>
                      </div>
                      <div className="d-flex  align-items-center ">
                        <div
                          className="Stars"
                          style={{ "--rating": course.rating, fontSize: "18px" }}
                          aria-label="Rating of this product is 2.3 out of 5."
                        ></div>
                        <h5 className="p-0 m-0">({course.rating})</h5>
                      </div>
                    </div>
                    <div className="courseDescription text-container">
                    </div>
                  </div>
                </div>
              ))}

              <div className="d-flex justify-content-end mt-4">
                <Pagination
                  current={currentPage}
                  pageSize={coursesPerPage}
                  total={enrolledCourses.length}
                  onChange={(page) => setCurrentPage(page)}
                  showSizeChanger={false}
                />
              </div>
            </>
          ) : (
            <div className="text-center mt-4">
              <h4>{t('NoCoursesAvailable')}</h4>
            </div>
          )}

          {suggested && (
            <>
              <h4 className="fw-bold myClassesHeading my-3">{t("SuggestedCourses")}</h4>
              <div id="suggestedCoursesCarousel" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                  {chunkArray(suggestedCourses, chunkSize).map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      data-bs-target="#suggestedCoursesCarousel"
                      data-bs-slide-to={index}
                      className={index === 0 ? "active" : ""}
                      aria-current={index === 0 ? "true" : "false"}
                      aria-label={`Slide ${index + 1}`}
                    ></button>
                  ))}
                </div>
                <div className="carousel-inner">
                  {chunkArray(suggestedCourses, chunkSize).map((chunk, chunkIndex) => (
                    <div key={chunkIndex} className={`carousel-item ${chunkIndex === 0 ? 'active' : ''}`}>
                      <div className="row">
                        {chunk.map((course, index) => (
                          <div key={index} className={`col-12 ${chunkSize === 3 ? 'col-md-4' : chunkSize === 2 ? 'col-md-6' : ''}`}>
                            <div 
                              className="col-12 col-md-12 customShadow courseCard px-2 py-2 position-relative d-flex flex-column gap-2 my-2"
                              onClick={() => showModal(course)}
                            >
                              <div className="CourseThumbnail">
                                <img
                                  src={course.coverImageUrl}
                                  className="rounded h-100 w-100"
                                  alt="course thumbnail"
                                />
                              </div>
                              <div className="position-absolute d-flex mt-1 ms-2 gap-3">
                                <Chip text='Best Seller' bg="#fffa7d" color="black" />
                                <Chip text={`${(course.discountedPrice / (course.discountedPrice + course.price) * 100).toFixed(2)} %`} bg="#A04AE3" color="white" />
                              </div>
                              <h6 className="mb-0 fw-bold">{course.courseTitle}</h6>
                              <div className="d-flex align-items-center courseInstructor d-md-flex flex-md-row flex-column">
                                <div className="d-flex">
                                  <User className="userIcon" />
                                  <h4 className="p-0 m-0 text-uppercase fg-main">
                                    {getInitials('Muhammad Kashif')}
                                  </h4>
                                </div>
                                <div className="d-flex align-items-center">
                                  <div
                                    className="Stars"
                                    style={{ "--rating": course.rating, fontSize: "18px" }}
                                    aria-label="Rating of this product is 2.3 out of 5."
                                  ></div>
                                  <h5 className="p-0 m-0">({course.rating})</h5>
                                </div>
                              </div>
                              <div className="courseDescription text-container">
                                {/* <p>{course.description}</p> */}
                              </div>
                              <div className="d-flex gap-3 pricing">
                                <h6 className="m-0 p-0 fw-bold salesPrice">
                                  ${course.price}
                                </h6>
                                <h6 className="m-0 p-0 text-sm normalPrice align-self-center">
                                  ${(course.discountedPrice + course.price)}
                                </h6>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#suggestedCoursesCarousel" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#suggestedCoursesCarousel" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </>
          )}
        
      </div>
      <Modal
        title={
          <div className="row d-flex justify-content-center p-0 m-0">
            <div className="col-md-12 examModalWrapper p-0 m-0">
              <div
                className={`d-flex justify-content-between align-items-center px-4 col-md-12 examModalHeader studentProfileHeading ${isArabic === "sa" ? "flex-row-reverse" : ""
                  }`}
              >
                <h4 style={{ color: "#060317" }} className="fw-bold">
                  {t("Course Entrollment")}
                </h4>
                <div className="iconWrapper cursor-pointer" onClick={handleCancel}>
                  <X />
                </div>
              </div>
            </div>
          </div>
        }
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={false}
        width={800}
      >
        <>
          <div className='row w-100 gx-0'>
            <div className="col-12 col-md-6  customShadow  courseCard px-2 py-2  d-flex flex-column gap-2 my-2">
              <div className="CourseThumbnail">
                <img
                  src={selectedCourse?.coverImageUrl}
                  className="rounded h-100 w-100"
                  alt="course thumbnail"
                />
              </div>
              <h6 className="mb-0 fw-bold">{selectedCourse?.name}</h6>
              <div className="d-flex align-items-center courseInstructor d-md-flex flex-md-row flex-column">
                <div className="d-flex">
                  <User className="userIcon" />
                  <h4 className="p-0 m-0 text-uppercase fg-main">
                    {getInitials("Muhammad Kashif")}
                  </h4>
                </div>
                <div className="d-flex align-items-center">
                  <div
                    className="Stars"
                    style={{ "--rating": selectedCourse?.rating || 0, fontSize: "18px" }}
                    aria-label="Rating of this course"
                  ></div>
                  <h5 className="p-0 m-0">({selectedCourse?.rating || 0})</h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 p-4">
              <div className="taskDetails cursor-pointer mb-3">
                <h6 className="mb-2">Price</h6>
                <p>${selectedCourse?.price}</p>
                <h6 className="mb-2">Discounted Price</h6>
                <p>${selectedCourse?.discountedPrice}</p>
                <h6 className="mb-2">Description</h6>
                <p>{selectedCourse?.description}</p>
              </div>
            </div>
          </div>
          <div className="d-flex gap-3 justify-content-end p-3">
            <span onClick={handleCancel}>
              <FlexBtn
                label={t("Cancel")}
                color="#463C77"
                bgColor="#EDEBF1"
              />
            </span>
            <span onClick={handleOk}>
              <FlexBtn
                label={t("Enroll")}
                color="white"
                bgColor="#463C77"
                style={{ fontSize: "14px" }}
              />
            </span>
          </div>
        </>
      </Modal>
    </Spin>
  );
};

export default Course;
